import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getGlobalLeaves } from "../../../../actions/globalLeaveAction";
import { Button } from "antd";
import RenderTable from "./RenderTable";
import CreateGlobalLeave from "./CreateGlobalLeave";

const GlobalLeaveList = ({ getGlobalLeaves, globalLeavelist }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [updatelist, setUpdatelist] = useState(true);

  useEffect(() => {
    getGlobalLeaves();
    setUpdatelist(true);
  }, [getGlobalLeaves]);

  return (
    <>
      <div style={{ marginBottom: 16, textAlign: "right" }}>
        <Button type="primary" onClick={() => setModalVisible(true)}>
          + Add Global Leave
        </Button>
      </div>

      <RenderTable
        data={globalLeavelist}
        updatelist={updatelist}
        setUpdatelist={setUpdatelist}
      />

      <CreateGlobalLeave
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        setUpdatelist={setUpdatelist}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  globalLeavelist: state.globalLeave.globalLeavelist,
});

export default connect(mapStateToProps, { getGlobalLeaves })(GlobalLeaveList);
